export default function getLimits(ranges) {
  return {
    min: ranges[0].from,
    max: ranges[ranges.length - 1].to,
  };
}
